<template>
  <div class="slider">
    <div class="slider-header">
      <h2 class="big-title big-title--pl">أعمالنا</h2>
    </div>
    <swiper :options="swiperOptions">
      <swiper-slide v-for="(item, i) in items" :key="i">
        <slide :item="item"></slide>
      </swiper-slide>
      <swiper-slide style="opacity:0"></swiper-slide>
      <swiper-slide style="opacity:0"></swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import Slide from './Slide'
export default {
  name: 'Slider',
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  components: {
    Slide,
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  data () {
    return {
      dragging: false,
      swiperOptions: {
        grabCursor: true,
        slidesPerView: 2,
        spaceBetween: 50,
        centeredSlides: false,
        breakpoints: {
          960: {
            slidesPerView: 2.7,
            spaceBetween: 200,
            centeredSlides: false
          },
          1400: {
            slidesPerView: 4,
            spaceBetween: 100,
            centeredSlides: false
          }
        },
        on: {
          sliderMove: function (e) {
            this.wrapperEl.parentElement.style.transition = ''
            this.wrapperEl.parentElement.style.filter = `blur(${Math.abs(e.movementX) % 5}px)`
          },
          transitionEnd: function (e) {
            this.wrapperEl.parentElement.style.transition = '.4s filter ease-out'
            this.wrapperEl.parentElement.style.filter = 'blur(0)'
          }
        }
      }
    }
  },
  computed: {
    isMobile () {
      return window.innerWidth <= 960
    }
  }
}
</script>

<style lang="scss">
  .slider {
    padding-top: 7rem;
  }
  .swiper-container {
    transition: .4s filter ease-out;
    & .swiper-slide:first-child {
      margin-right: 2rem;
      @media screen and (min-width: 960px) {
        margin-right: 11rem;
      }
    }
  }
</style>
